import { InjectionToken } from '@angular/core';

import { SectionsEnum } from '../enums/sections.enum';

export const JOBS_PLACEMENTS_EMPTY_TEXT_TOKEN =
    new InjectionToken<Partial<Record<SectionsEnum, string>>>('Empty texts for jobs and placements');
